import { z } from "zod";

export const TransitionKind = z.enum([
  "NONE",
  "FADE",
  "FADE_BLACK",
  "FADE_WHITE",
  "PUSH",
  "WIPE",
  "ZOOM_IN_FADE",
  "ZOOM_IN_OUT",
  "ZOOM_BLUR",
  "ZOOM_OUT_BLUR",
  "GLITCH_CUT",
  "FOCUS_PULL",
  "WHIP_PAN",
  "CLOCK_WIPE",
  "SPLIT_REVEAL",
  "SPLIT_SCREEN_WIPE",
  "LIGHT_LEAK",
]);

export const TransitionSpeed = z.enum(["SLOW", "NORMAL", "FAST"]);
export const TransitionDirection = z.enum([
  "FROM_LEFT",
  "FROM_RIGHT",
  "FROM_TOP",
  "FROM_BOTTOM",
  "FROM_TOP_RIGHT",
  "FROM_TOP_LEFT",
  "FROM_BOTTOM_RIGHT",
  "FROM_BOTTOM_LEFT",
]);

export const TransitionSound = z.enum([
  "FAST_AIR_SWOOSH",
  "SOFT_CINEMATIC_WHOOSH",
  "SHORT_SOFT_WHOOSH",
  "SWOOSH_1",
  "EPIC_CINEMATIC_BOOM",
  "SUBTLE_FUTURISTIC_BLIP",
  "SHORT_GLITCH",
  "DIGITAL_GLITCH_SWIPE",
  "CINEMATIC_IMPACT",
  "SOFT_WHOOSH",
  "SHORT_SOFT_TRANSITION",
  "CLEAN_UI_WHOOSH",
  "CLEAN_TECH_WHOOSH",
  "CLEAN_TICKING",
  "ELEGANT_RISER",
  "SOFT_RISER_WHOOSH",
  "EPIC_CINEMATIC_BOOM_2",
  "CINEMATIC_BASS_HIT",
  "MAGICAL_REVEAL",
  "ARCANE_CHIME",
  "MYSTICAL_AMBIENCE",
  "CAMERA_FLASH",
  "CAMERA_SHUTTER",
  "VINTAGE_FILM_CAMERA",
  "SOFT_TICKING",
]);

export const MAX_TRANSITION_SEED = 2147483647;
// 1 plays a sound at its leveled default loudness; above that boosts it.
export const MAX_TRANSITION_SOUND_VOLUME = 2;

export const TransitionDto = z.object({
  kind: TransitionKind,
  speed: TransitionSpeed.optional(),
  direction: TransitionDirection.optional(),
  intensity: z.number().min(0).max(1).optional(),
  seed: z.number().int().min(0).max(MAX_TRANSITION_SEED).optional(),
  sound: TransitionSound.optional(),
  volume: z.number().min(0).max(MAX_TRANSITION_SOUND_VOLUME).optional(),
});

export type TransitionKind = z.infer<typeof TransitionKind>;
export type TransitionSpeed = z.infer<typeof TransitionSpeed>;
export type TransitionDirection = z.infer<typeof TransitionDirection>;
export type TransitionSound = z.infer<typeof TransitionSound>;
export type TransitionDto = z.infer<typeof TransitionDto>;
